import type { CRMProps } from "@/components/atomic-crm/root/CRM";

export const rcAvenueConfiguration: CRMProps = {
  title: "RC Avenue Commercial Hub",
  currency: "EUR",
  disableTelemetry: true,
  companySectors: [
    { value: "agroalimentare", label: "Agroalimentare" },
    { value: "bio-naturale", label: "Bio e naturale" },
    { value: "artigianato-design", label: "Artigianato e design" },
    { value: "moda-accessori", label: "Moda e accessori" },
    { value: "beauty-personal-care", label: "Bellezza e cura personale" },
    { value: "casa-lifestyle", label: "Casa e lifestyle" },
    { value: "benessere", label: "Benessere" },
    { value: "altro", label: "Altro" },
  ],
  dealCategories: [
    { value: "lista-carlo", label: "Lista Carlo" },
    { value: "direttore-commerciale", label: "Direttore commerciale" },
    { value: "giuseppe-mancini", label: "Giuseppe Mancini" },
    { value: "raffaele-bitetti", label: "Raffaele Bitetti" },
    { value: "stefano-bidolo", label: "Stefano Bidolo" },
    { value: "referral", label: "Referral" },
    { value: "altro", label: "Altro" },
  ],
  dealStages: [
    { value: "opportunity", label: "Da contattare" },
    { value: "proposal-sent", label: "Contattato" },
    { value: "in-negociation", label: "Interessato" },
    { value: "delayed", label: "Onboarding" },
    { value: "won", label: "Acquisito" },
    { value: "lost", label: "Non acquisito" },
  ],
  dealPipelineStatuses: ["won"],
  noteStatuses: [
    { value: "cold", label: "Freddo", color: "#7dbde8" },
    { value: "warm", label: "Tiepido", color: "#e8cb7d" },
    { value: "hot", label: "Caldo", color: "#e88b7d" },
    { value: "in-contract", label: "Prioritario", color: "#a4e87d" },
  ],
  taskTypes: [
    { value: "none", label: "Nessuna" },
    { value: "call", label: "Telefonata" },
    { value: "email", label: "Email" },
    { value: "whatsapp", label: "WhatsApp" },
    { value: "meeting", label: "Meeting" },
    { value: "follow-up", label: "Follow-up" },
    { value: "documentation", label: "Documentazione" },
    { value: "merchant-review", label: "Verifica merchant" },
    { value: "other", label: "Altro" },
  ],
};
